export default __webpack_public_path__ + "static/media/IMG_4246.d2c0de59.JPG";